// pages/AuthPage.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import DualLogin from '../components/DualLogin';

const AuthPage = () => {
  const { currentUser } = useAuth();

  if (currentUser) {
    return <Navigate to="/trackmed2" replace />;
  }

  return <DualLogin />;
};

export default AuthPage;